import { css } from '@emotion/css';

export const applicationCardCx = css`
  background-color: #ffffff;
  padding: 1.25rem 1rem;
`;
